<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
    <path
      d="M15.2081 0.695801L8.8068 0.695801L8.8068 6.21878C8.8068 7.81166 8.86634 8.51133 9.0301 9.64273L8.65793 9.76182C8.15178 8.71975 7.91359 8.22849 7.4521 7.40972L7.16926 6.90357L0.5 6.90357L11.4715 19.3042H12.4987L23.5 6.90357L16.8605 6.90357L16.5777 7.40972C16.1162 8.22849 15.8631 8.71975 15.3718 9.76182L14.9997 9.64273C15.1634 8.51133 15.2081 7.81166 15.2081 6.21878L15.2081 0.695801Z"
      fill="currentColor"
    />
  </svg>
</template>
